export class VenueModelResponse {
  constructor (
    public id?: string,
    public name?: string,
    public description?: string,
    public address?: string,
    public city?: string,
    public postalCode?: string,
    public formatedAddress?: string,
    public countryCode?: string,
    public pictureUrl?: string,
    public websiteUrl?: string,
    public businessTypes?: any,
    public rate?: number,
    public myRate?: number,
    public latitude?: number,
    public longitude?: number,
    public numberOfReviews?: number,
    public email?: string,
    public phone?: string,
    public isUserFavourite?: boolean,
    public tags?: string[],
    public maximumCapacity?: number,
    public galeryImages?: string[],
    public checked?: boolean,
    public HostsIds?: Array<string>,
    public sendLocationNotifications?: boolean,
  ) {}
}

export class VenueModelRequest {
  constructor (
    public Name?: string,
    public Description?: string,
    public Address?: string | null,
    public FormatedAddress?: string | null,
    public City?: string | null,
    public PostalCode?: string | null,
    public CountryCode?: string | null,
    public BusinessTypesIds?: number[],
    public MaximumCapacity?: number,
    public GooglePlaceId?: string | null,
    public WebsiteUrl?: string,
    public Email?: string,
    public Phone?: string,
    public Latitude?: number,
    public Longitude?: number,
    public Tags?: string[],
    public VenueImageFile?: string | ArrayBuffer,
    public HostsIds?: Array<string>,
    public SendLocationNotifications?: boolean,
  ) {}
}